import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import PanelHead from "../../../components/panel-head";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { ListItem, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { setLoading, setSnackbarMsg } from "../../../store/reducers/misc";
import { useDispatch, useSelector } from "react-redux";
import { addCredential, getAllApplications, getCredentials } from "../../../lib/request";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import { setApplications } from "../../../store/reducers/application";
import { setCredentials } from "../../../store/reducers/credentials";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledDiv = styled(Box)`
  ${({ theme }) => `
    
  `}
`;

export default function CredentialCreate() {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { me } = useSelector((state) => state.profile);
  const applications = useSelector((state) => state.application.applications);
  console.log(applications);

  const [form, setForm] = useState({
    name: "",
    nameErr: null,
    redirectUriErr: null,
    sso_key: "",
    ssoKeyErr: null,
    t_name: "",
    ga: "",
    payPrefix: "",
    dc_url: "",
    network: "",
    brand: "",
  });
  const [redirectUris, setRedirectUris] = useState([{ redirect_uri: "" }]);
  const [application, setApplication] = useState({});

  useEffect(() => {
    if (_.isEmpty(applications)) {
      getAllApplications()
        .then((res) => {
          dispatch(setApplications(res.data));
          getApiKey(res.data);
        })
        .then(() => getCredentials())
        .then((res) => dispatch(setCredentials(res.data.credentials)))
        .catch((err) => console.log(err.response.data.message));
    } else {
      getApiKey(applications);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applications]);

  function getApiKey(applications) {
    const applicationInView = _.find(applications, { id: parseInt(id) });
    if (applicationInView) {
      const formClone = _.cloneDeep(form);
      formClone.sso_key = applicationInView.apiKey;
      formClone.network = applicationInView.Brands.Networks.map((item) => item.name).join(", ");
      formClone.brand = applicationInView.Brands.name;
      setForm(formClone);
      setApplication(applicationInView);
    }
  }

  function addRedirectUri() {
    setRedirectUris([...redirectUris, { redirect_uri: "" }]);
  }

  function removeRedirectUris(index) {
    const rows = [...redirectUris];
    rows.splice(index, 1);
    setRedirectUris(rows);
  }

  function handleChange(index, e) {
    const { name, value } = e.target;
    const list = [...redirectUris];
    list[index][name] = value;
    setRedirectUris(list);

    const formClone = _.cloneDeep(form);
    formClone.redirectUriErr = null;
    setForm(formClone);
  }

  function changeForm(e) {
    const { name, value } = e.target;
    const formClone = _.cloneDeep(form);

    formClone[name] = value;
    formClone.nameErr = null;
    formClone.redirectUriErr = null;
    formClone.ssoKeyErr = null;

    setForm(formClone);
  }

  function submit(e) {
    e.preventDefault();
    e.stopPropagation();

    const formClone = _.cloneDeep(form);

    let redirectUriArr = [];
    _.forEach(redirectUris, function (value) {
      if (!_.isEmpty(_.trim(value.redirect_uri))) {
        redirectUriArr.push(value.redirect_uri);
      }
    });

    formClone.redirect_uri = redirectUriArr.toString();

    let err = false;
    if (_.isEmpty(_.trim(form.name))) {
      err = true;
      formClone.nameErr = "Name is required";
    }
    if (_.isEmpty(_.trim(formClone.redirect_uri))) {
      err = true;
      formClone.redirectUriErr = "Redirect Uri is required";
    }
    if (_.isEmpty(_.trim(form.sso_key))) {
      err = true;
      formClone.ssoKeyErr = "SSO key is required";
    }

    if (err) {
      return setForm(formClone);
    }

    dispatch(setLoading(true));

    addCredential(formClone)
      .then(() => getCredentials())
      .then((res) => dispatch(setCredentials(res.data.credentials)))
      .then(() => {
        dispatch(setSnackbarMsg("Credentials created"));
        navigate(`/application/credentials/${id}`);
      })
      .catch((err) => {
        if (err.response) {
          dispatch(setSnackbarMsg(err.response.data.msg));
        }
      })
      .finally(() => dispatch(setLoading(false)));
  }

  return (
    <StyledDiv>
      <PanelHead title={`New credential`} subtitle={application.label}>
        <Link to={`/application/credentials/${id}`}>
          <Button fullWidth={isMobile} variant={isMobile ? "outlined" : "text"} color={"inherit"} sx={{ mr: isMobile ? 0 : 2, mb: isMobile ? 1 : 0 }}>
            Back
          </Button>
        </Link>
        {!_.isEmpty(me) && me.permission.includes("U") && (
          <Button fullWidth={isMobile} variant="outlined" disabled={_.isEmpty(form.sso_key)} onClick={submit}>
            Save
          </Button>
        )}
      </PanelHead>
      <Box sx={{ p: 2 }}>
        <Box component="form" noValidate onSubmit={submit}>
          <Grid container spacing={2}>
            <Grid xs={6}>
              <TextField
                required
                fullWidth
                type="text"
                margin="normal"
                label="Application Name"
                name="name"
                InputLabelProps={{ shrink: true }}
                error={!_.isEmpty(form.nameErr)}
                helperText={form.nameErr}
                value={form.brand}
                onChange={changeForm}
              />
            </Grid>
            <Grid xs={6}>
              <TextField fullWidth margin={"normal"} label="t_name" variant="outlined" value={form.t_name} name={"t_name"} InputLabelProps={{ shrink: true }} onChange={changeForm} />
            </Grid>
            <Grid xs={6}>
              <TextField fullWidth margin={"normal"} label="Direct checkout Url" variant="outlined" value={form.dc_url} name={"dc_url"} InputLabelProps={{ shrink: true }} onChange={changeForm} />
            </Grid>
            <Grid xs={6}>
              <TextField fullWidth margin={"normal"} label="ga id" variant="outlined" value={form.ga} name={"ga"} InputLabelProps={{ shrink: true }} onChange={changeForm} />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid xs={12} md={10}>
              <Typography variant={"h5"}>Redirect Uri</Typography>
            </Grid>
            <Grid xs={12} md={2} sx={{ textAlign: "right" }}>
              <Button variant="outlined" onClick={addRedirectUri}>
                Add
              </Button>
            </Grid>
          </Grid>

          <List>
            {redirectUris.map((data, index) => {
              const { redirect_uri } = data;
              return (
                <ListItem
                  disableGutters
                  key={index}
                  secondaryAction={
                    redirectUris.length !== 1 && (
                      <IconButton edge="end" aria-label="delete" onClick={() => removeRedirectUris(index)}>
                        <DeleteIcon />
                      </IconButton>
                    )
                  }
                >
                  <TextField
                    fullWidth
                    required
                    margin={"normal"}
                    label="Redirect Uri"
                    variant="outlined"
                    value={redirect_uri}
                    error={!_.isEmpty(form.redirectUriErr)}
                    helperText={form.redirectUriErr}
                    name={"redirect_uri"}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => handleChange(index, e)}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Box>
    </StyledDiv>
  );
}
